import { render, staticRenderFns } from "./LPRData.vue?vue&type=template&id=5801d762"
import script from "./LPRData.vue?vue&type=script&lang=js"
export * from "./LPRData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports